import { useInjection } from 'inversify-react';

import { IManageBookingRepository, ManageBookingRepositorySymbol } from 'domain/repositories/ManageBookingsRepository';

export const useCaseListMyBookings = (isUS: boolean) => {
  const repository = useInjection<IManageBookingRepository>(ManageBookingRepositorySymbol);
  return repository.useListMyBookings(isUS);
};
